import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderTopResult() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >


                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_10.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_10.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                {/* <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_11.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_11.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_12.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_12.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide> */}


                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Miss Shreya singh.webp" style={{ borderRadius: "10px", height: "250px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Miss Shreya singh.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_1.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_1.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_2.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_2.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_3.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_3.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_4.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_4.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_5.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_5.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_6.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_6.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_7.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_7.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_8.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_8.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/school/Top Result_9.webp" style={{ borderRadius: "10px" }} className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a to="assets/school/Top Result_9.webp" data-fancybox="gallery">
                            </a>
                        </div>
                    </div>
                </SwiperSlide>


            </Swiper>
        </>
    );
}
